/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Container,
  Fade,
  Stack,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system';

// Wimss context
import {
  useWimssController,
  setIsMobile,
  setCurrentPage,
  setCurrentTexts,
} from 'context';

import { initTexts } from 'utils/syncState';

//import hero pictures and background images
import SandyBeach from 'assets/images/pictures/sandy-beach.png';
import Aboutus from 'assets/images/pictures/about-us.png';
import AboutusBanner from 'assets/images/pictures/aboutus-banner.png';

const AboutUsHero = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${AboutusBanner})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
        overflow: 'hidden',
        overflowY: 'auto',
        width: '100vw',
        height: '100%',
        position: 'relative',
      }}>
      <Fade
        in={true}
        style={{
          transitionDelay: 500,
        }}>
        <img
          src={AboutusBanner}
          alt={'Latest AboutUs'}
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </Fade>
    </Box>
  );
};

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'scale(1.02)',
  },
}));

const TeamContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));

const AboutUs = () => {
  const [controller, dispatch] = useWimssController();
  const { currentLanguage, isMobile, currentPage, currentTexts } = controller;

  const Page = 'about-us';
  const { innerWidth: width } = window;

  const [refreshActBtn, setRefreshActBtn] = useState(true);

  useEffect(() => {
    if (width <= 600) {
      setIsMobile(dispatch, true);
    } else setIsMobile(dispatch, false);
    setCurrentPage(dispatch, Page);
  }, []);

  useEffect(() => {
    // initHero(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (currentLanguage !== '') {
      setRefreshActBtn(false);
    }

    //set pageTexts
    let pageTxts = initTexts(currentLanguage, currentPage);
    setCurrentTexts(dispatch, pageTxts);
  }, [currentLanguage, currentPage]);

  useEffect(() => {
    if (currentTexts !== null) setRefreshActBtn(true);
  }, [currentTexts]);

  return (
    <Box sx={{ flexGrow: 1, mt: 0 }}>
      {currentTexts !== null && (
        <Grid container direction='column' spacing={{ xs: 3, md: 4 }}>
          <Grid size={12}>
            <AboutUsHero />
          </Grid>
        </Grid>
      )}
      <TeamContainer maxWidth='xl' sx={{ mt: isMobile ? 0 : 0 }}>
        {currentTexts !== null && (
          <Grid container spacing={isMobile ? 0 : 3}>
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  overflow: 'auto',

                  width: '100%',
                  height: '100%',

                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}>
                <Stack direction='column' align='left'>
                  <img
                    src={Aboutus}
                    style={{
                      maxWidth: isMobile ? '90%' : '100%',
                      height: 'auto',
                    }}
                    alt='Our Team'
                  />
                  <Typography
                    variant='body'
                    sx={{
                      maxWidth: isMobile ? '90%' : '100%',
                      fontSize: isMobile ? '1rem' : '1.2rem',
                    }}>
                    {currentTexts[0].description}
                  </Typography>
                </Stack>
              </Box>
            </Grid>

            <Grid item xs={12} md={7} sx={{ mt: isMobile ? 4 : 0 }}>
              <Grid container spacing={isMobile ? 0 : 3}>
                {currentTexts[0].paragraphs.map((member, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    key={index}
                    sx={{ mt: isMobile ? 2 : 0 }}>
                    <StyledCard>
                      <CardMedia
                        component='img'
                        height='250'
                        image={member.image}
                        alt={member.name}
                        sx={{ objectFit: 'cover' }}
                      />
                      <CardContent align='left'>
                        <Typography variant='h6' gutterBottom>
                          {member.name}
                        </Typography>
                        <Typography
                          variant='subtitle1'
                          color='primary'
                          gutterBottom>
                          {member.title}
                        </Typography>
                        <Typography variant='body2' color='text.secondary'>
                          {member.content}
                        </Typography>
                      </CardContent>
                    </StyledCard>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        )}
      </TeamContainer>
      <Box
        sx={{
          backgroundImage: `url(${SandyBeach})`,
          overflowY: 'auto',
          width: '100vw',
          height: 200,

          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}></Box>
    </Box>
  );
};

export default AboutUs;
